export default {
  siteOwnerships: []
}
